import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router';
import { useMutation } from '@tanstack/react-query';
import { Button, Center, Spinner, Stack, Text } from '@chakra-ui/react';
import { LuCircleCheck, LuCircleX } from 'react-icons/lu';
import { acceptInviteService } from '@/services/agendas';

const AcceptInvite = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();

  const { mutate, isPending, isSuccess, isError } = useMutation({
    mutationFn: () => acceptInviteService(token!),
  });

  useEffect(() => {
    mutate();
  }, [mutate]);

  if (isPending) {
    return (
      <Center h="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  return (
    <Center h="100vh">
      <Stack align="center" gap="4">
        {isSuccess && (
          <>
            <LuCircleCheck size={48} color="green" />
            <Text fontSize="xl" fontWeight="semibold">Convite aceito com sucesso!</Text>
            <Text color="fg.muted">Você agora é membro da agenda.</Text>
          </>
        )}
        {isError && (
          <>
            <LuCircleX size={48} color="red" />
            <Text fontSize="xl" fontWeight="semibold">Não foi possível aceitar o convite.</Text>
            <Text color="fg.muted">O link pode ter expirado ou já foi utilizado.</Text>
          </>
        )}
        <Button size="sm" onClick={() => navigate('/painel/agendas')}>
          Ir para Agendas
        </Button>
      </Stack>
    </Center>
  );
};

export default AcceptInvite;
